import { Skeleton } from 'antd';

export const HeaderSkeleton = () => {
  return (
    <Skeleton
      active
      title={false}
      paragraph={{
        rows: 2,
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          margin: 0,
        },
      }}
    />
  );
};